// internal
import { axios, def, handleError, handleResponse } from './internal';

function AdminUserProfile(service, targetId, setData) {
    axios
        .post('/api/admin_user_profile', {
            service,
            targetId,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const {
                        username,
                        image,
                        thumbnail,
                        filterDesc,
                        profileDesc,
                        lastLoginAt,
                        blocked,
                        inactive,
                        subscription,
                        badges,
                        preferences,
                        nsfw,
                        nsfwComment,
                        nsfwMessage,
                        censoredComments,
                        legal,
                        posts,
                    } = res.data.data;
                    setData((prev) => ({
                        username,
                        image,
                        thumbnail,
                        filterDesc,
                        profileDesc,
                        lastLoginAt,
                        blocked,
                        inactive,
                        subscription,
                        badges,
                        preferences,
                        restrictionPost: nsfw,
                        restrictionComment: nsfwComment,
                        restrictionMessage: nsfwMessage,
                        censoredComments: censoredComments ?? [],
                        legal,
                        posts,
                    }));
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserProfile };
